import type { MakeRequest } from "./types/MakeRequest";
import type { Options } from "./types/Options";

export const makeGet =
  ({ makeRequest }: { makeRequest: MakeRequest }) =>
  (url: string, options: Options = {}) => {
    options.method = "get";

    return makeRequest(url, options);
  };
